import { formatToISONonUTCStartOfDay } from '../functions/helpers';

export const emptyPlug = '--';

export const supportEmail = 'support2.0@wagepoint.com';

export const minDobStartDate = new Date(formatToISONonUTCStartOfDay('1900-01-01'));
